/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospPatientCatMiscCharges from './hosp-patient-cat-misc-charges';
import HospPatientCatMiscChargesDetail from './hosp-patient-cat-misc-charges-detail';
import HospPatientCatMiscChargesUpdate from './hosp-patient-cat-misc-charges-update';
import HospPatientCatMiscChargesDeleteDialog from './hosp-patient-cat-misc-charges-delete-dialog';

const HospPatientCatMiscChargesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospPatientCatMiscCharges />} />
    <Route path="new" element={<HospPatientCatMiscChargesUpdate />} />
    <Route path=":id">
      <Route index element={<HospPatientCatMiscChargesDetail />} />
      <Route path="edit" element={<HospPatientCatMiscChargesUpdate />} />
      <Route path="delete" element={<HospPatientCatMiscChargesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospPatientCatMiscChargesRoutes;
